import AppApi from '../AppApi';

const appApi = new AppApi();

export const get = (
	path: string,
	signal?: AbortSignal,
	useToken?: boolean,
	withJsonContentType?: boolean,
	withBlob?: boolean
) => {
	return appApi.ajax('get', path, null, signal, useToken, withJsonContentType, withBlob);
};

export const post = (
	path: string,
	data: unknown,
	signal?: AbortSignal,
	useToken?: boolean,
	withJsonContentType?: boolean,
	withBlob?: boolean
) => {
	return appApi.ajax('post', path, data, signal, useToken, withJsonContentType, withBlob);
};

export const put = (
	path: string,
	data: unknown,
	signal?: AbortSignal,
	useToken?: boolean,
	withJsonContentType?: boolean
) => {
	return appApi.ajax('put', path, data, signal, useToken, withJsonContentType);
};

export const httpDelete = (path: string, data?: unknown, signal?: AbortSignal) => {
	return appApi.ajax('delete', path, data, signal, true);
};
